<template>
     <div class="container-fluid p-0">
        <div class="row m-0">
          <div class="col-12 p-0 ">
            <div class="login-card">
              <form class="theme-form login-form" @submit.prevent="createUser">
                <h4 class="mb-3">Create your account</h4>
                <div class="form-group">
                  <label>Name</label>
                  <div class="small-group">
                    <div class="input-group"><span class="input-group-text"><i class="icon-user"></i></span>
                      <input class="form-control" v-model="username" type="text" required="" placeholder="Name">
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label>Phone</label>
                  <div class="small-group">
                      <div class="input-group"><span class="input-group-text"><i class="icon-headphone-alt"></i></span>
                          <input class="form-control" v-model="phone" type="text" required="" placeholder="Phone">
                      </div>
                  </div>
                </div>
                <div class="form-group">
                  <label>Email Address</label>
                  <div class="input-group"><span class="input-group-text"><i class="icon-email"></i></span>
                    <input class="form-control" type="email" required="" v-model="email" placeholder="Test@gmail.com">
                  </div>
                </div>
                <div class="form-group">
                  <label>Password</label>
                  <div class="input-group"><span class="input-group-text"><i class="icon-lock"></i></span>
                    <input class="form-control" :type="passwordType" v-model="password" name="login[password]" required="" placeholder="*********">
                    <div class="show-hide"><span class="show" @click="togglePassword"></span></div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="checkbox">
                    <input id="checkbox1" type="checkbox">
                    <label class="text-muted" for="checkbox1">Agree with <span>Privacy Policy</span></label>
                  </div>
                </div>
                <div class="form-group">
                  <button class="btn btn-primary btn-block" type="submit">Create Account</button>
                </div>
                <p>Already have an account?<a class="ms-2" href="/auth/login">Sign in</a></p>
              </form>
            </div>
          </div>
        </div>
      </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useAuth } from "@/composables/useAuth";
import { createToaster } from "@meforma/vue-toaster";

const toaster = createToaster({
    position: "top-right",
    duration: 2000,
});

const router = useRouter();
const { createUserApi } = useAuth();

const username = ref("");
const password = ref("");
const email = ref("");
const phone = ref("");
const passwordType = ref("password");

const togglePassword = () => {
  passwordType.value = passwordType.value === "password" ? "text" : "password";
};

const createUser = async () => {
    const params = {
        username: username.value,
        password: password.value,
        email: email.value,
        phone: phone.value,
        alias: "newuser",
    };

    const result = await createUserApi(params);

    if (result.success && result.data) {
        toaster.success('Thành công!');
        router.replace('/auth/login');

    } else {
        toaster.error("Có lỗi xảy ra: " + (result.error || 'Lỗi hệ thống'));
    }
};
</script>
